import { Route, Routes } from 'react-router-dom';
import './App.css';
import Login from './pages/Auth/Login';
import Signup from './pages/Auth/Signup';
import FileUploader from './pages/FileUploader/FileUploader';
import PdfUploader from './pages/PdfUploader/PdfUploader';
import { Uploader } from './pages/GeneralUploader/Uploader';
import DocumentStudio from './pages/DocumentStudio/DocumentStudio';
import EduStudio from './pages/EduStudio/EduStudio';
import CareerSync from './pages/CareerSync/CareerSync';
import ArchitectStudio from './pages/ArchitectStudio/ArchitectStudio';
import OmAssist from './components/OmAssist/OmAssist';
import InstallPWA from './components/InstallPWA/InstallPWA';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path='/' element={<FileUploader />} />
        <Route path='/uploader' element={<Uploader />} />
        <Route path='/signin' element={<Login />} />
        <Route path='/signup' element={<Signup />} />
        <Route path="/pdf-compressor" element={<PdfUploader />} />
        <Route path="/vision-studio" element={<DocumentStudio />} />
        <Route path="/edu-studio" element={<EduStudio />} />
        <Route path="/career-sync" element={<CareerSync />} />
        <Route path="/architect-studio" element={<ArchitectStudio />} />
      </Routes>

      {/* ── Om Assist Chatbot — universal across all pages ── */}
      <OmAssist />

      {/* ── PWA Install Prompt — shows on first visit ── */}
      <InstallPWA />
    </div>
  );
}

export default App;
